<script>
import SlotItemTableMobile from "./SlotItemTableMobile.vue";

export default {
  name: 'SlotsTableMobile',
  props: ['data', 'getDateAndMonth', 'getTime'],
  components: { SlotItemTableMobile },
}
</script>

<template>
  <div class="invoice-rd">
    <div class="flex flex--col gap-12">
      <slot-item-table-mobile
        v-for="slot in data"
        :key="slot.treatment"
        :data="slot"
        :get-date-and-month="getDateAndMonth"
        :get-time="getTime"
    />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "./../../less/redesign/vars";
.text-left {
  text-align: left;
}
.gap-12 {
  gap: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/tbooking-widget/SlotsTableMobile.vue